import { colors } from '@material-ui/core';
import {
  approved,
  black,
  blue,
  darkGray,
  error,
  gray,
  green,
  invalid,
  navOperator,
  lightGray,
  orange,
  pink,
  red,
  skyOne,
  success,
  superLightGray,
  validating,
  waiting,
  white,
  yellow,
  borderGray,
  lightGreen,
  lightYellow,
  lightRed,
  darkGreen,
  darkYellow,
  darkRed,
  autoSkyBlue,
  navSuperAdmin,
  sideGray,
  navAdmin,
  lightShadow,
  mediumShadow,
  darkShadow,
  navAdminActions,
  navSuperAdminActions,
  navCompanyContextActions,
  navOperatorActions,
  lightNavAdminActions,
  lightNavSuperAdminActions,
  lightNavCompanyContextActions,
  lightNavOperatorActions,
  transparent,
  greyCardBorder,
  superLightYellow,
  superDarkYellow,
  shadedWhite,
  passwordBlue,
  backgroundWhite,
  deepBlack,
  strongGray,
  darkerGray,
  messageGreen,
  iconYellow,
  dashYellow,
  dashRed,
  dashGreen,
  dashLightYellow,
  dashTurquoise,
  dashBlue,
  dashPink,
  dashLightPink,
  checkedLightYellow,
  superLightGreen,
  superLightRed,
  backgroundSuperLightRed,
  deepBlue,
  digitalBlue,
  offWhite,
  limeGreen,
  lightBlue,
  pinkAccent,
  blackC,
  grey900,
  grey800,
  grey700,
  grey600,
  grey500,
  grey400,
  grey300,
  grey200,
  lightDeepBlue,
  lightDigitalBlue,
  lightLimeGreen,
  lightLightBlue,
  lightPinkAccent,
  lightGrey800,
  lightGrey400,
  backgroundLightGreen,
  backgroundLightRed,
  superLightDeepBlue,
  deepBlueLight1,
  deepBlueLight2,
  deepBlueLight3,
  deepBlueDark1,
  deepBlueDark2,
  deepBlueDark3,
  deepBlueDark4,
  digitalBlueLight1,
  digitalBlueLight2,
  digitalBlueLight3,
  digitalBlueDark1,
  digitalBlueDark2,
  digitalBlueDark3,
  digitalBlueDark4,
  lightBlueLight1,
  lightBlueLight2,
  lightBlueLight3,
  lightBlueDark1,
  lightBlueDark2,
  lightBlueDark3,
  lightBlueDark4,
  backgroundBlue,
  insideFormGray,
  sideGrayLighter,
  logsLightGreen,
  logsLightGray,
  logsLightRed,
  logsLightBlue,
  logsLightYellow,
  logsBlue,
  logsGreen,
  logsGray,
} from './colors';

export default {
  skyOne,
  gray,
  green,
  blue,
  pink,
  red,
  yellow,
  orange,
  superLightGray,
  darkGray,
  black,
  white,
  lightGray,
  navOperator,
  primary: {
    contrastText: white,
    dark: deepBlue,
    main: deepBlue,
    light: deepBlue[400],
  },
  secondary: {
    contrastText: white,
    dark: blue,
    main: blue,
    light: blue[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: gray,
    secondary: gray,
    link: colors.blue[600],
  },
  link: colors.blue[800],
  icon: darkGray,
  background: {
    default: lightGray,
    paper: white,
  },
  divider: colors.grey[200],
  status: {
    error,
    success,
    waiting,
    validating,
    approved,
    invalid,
  },
  borderGray,
  lightGreen,
  lightYellow,
  lightRed,
  darkGreen,
  darkYellow,
  darkRed,
  autoSkyBlue,
  navSuperAdmin,
  sideGray,
  navAdmin,
  lightShadow,
  mediumShadow,
  darkShadow,
  navAdminActions,
  navSuperAdminActions,
  navCompanyContextActions,
  navOperatorActions,
  lightNavAdminActions,
  lightNavSuperAdminActions,
  lightNavCompanyContextActions,
  lightNavOperatorActions,
  transparent,
  greyCardBorder,
  superLightYellow,
  superDarkYellow,
  shadedWhite,
  passwordBlue,
  backgroundWhite,
  deepBlack,
  strongGray,
  darkerGray,
  messageGreen,
  iconYellow,
  dashYellow,
  dashRed,
  dashGreen,
  dashLightYellow,
  dashTurquoise,
  dashBlue,
  dashPink,
  dashLightPink,
  checkedLightYellow,
  superLightGreen,
  superLightRed,
  backgroundSuperLightRed,
  deepBlue,
  digitalBlue,
  offWhite,
  limeGreen,
  lightBlue,
  pinkAccent,
  blackC,
  grey900,
  grey800,
  grey700,
  grey600,
  grey500,
  grey400,
  grey300,
  grey200,
  lightDeepBlue,
  lightDigitalBlue,
  lightLimeGreen,
  lightLightBlue,
  lightPinkAccent,
  lightGrey800,
  lightGrey400,
  backgroundLightGreen,
  backgroundLightRed,
  superLightDeepBlue,
  deepBlueLight1,
  deepBlueLight2,
  deepBlueLight3,
  deepBlueDark1,
  deepBlueDark2,
  deepBlueDark3,
  deepBlueDark4,
  digitalBlueLight1,
  digitalBlueLight2,
  digitalBlueLight3,
  digitalBlueDark1,
  digitalBlueDark2,
  digitalBlueDark3,
  digitalBlueDark4,
  lightBlueLight1,
  lightBlueLight2,
  lightBlueLight3,
  lightBlueDark1,
  lightBlueDark2,
  lightBlueDark3,
  lightBlueDark4,
  backgroundBlue,
  insideFormGray,
  sideGrayLighter,
  logsLightGreen,
  logsLightGray,
  logsLightRed,
  logsLightBlue,
  logsLightYellow,
  logsBlue,
  logsGreen,
  logsGray,
};
